import {
  Box,
  SimpleGrid,
  Icon,
  Text,
  Stack,
  Flex,
  useColorModeValue,
  Heading,
} from "@chakra-ui/react";
import { ReactComponent as NodeIcon } from "../../Images/Backend/nodejs-icon.svg";
import { ReactComponent as ExpressIcon } from "../../Images/Backend/express.svg";
import { ReactComponent as MongoDBIcon } from "../../Images/Backend/mongodb.svg";
import { ReactComponent as MySQLIcon } from "../../Images/Backend/mysql.svg";
import { ReactComponent as PostgresqlIcon } from "../../Images/Backend/postgresql.svg";
import { ReactComponent as PrismaIcon } from "../../Images/Backend/prisma.svg";
import { ReactComponent as StrapiIcon } from "../../Images/Backend/strapi.svg";
import SupabaseIcon from "../../Images/Backend/supabase.png";

const Feature = ({ title, text, icon, iconType }) => {
  return (
    <Stack
      align={"center"}
      px={8}
      py={4}
      boxShadow={"xl"}
      color={useColorModeValue("gray.600", "gray.600")}
      bgGradient="linear(to-b, gray.50, gray.200)"
      rounded={"lg"}
      transform="scale(1.0)"
      objectFit="contain"
      width="100%"
      transition="0.2s ease-in-out"
      _hover={{
        transform: "scale(1.1)",
      }}
    >
      <Flex
        w={16}
        align={"center"}
        justify={"center"}
        color={"white"}
        rounded={"full"}
        mb={1}
      >
        {iconType == "imagefile" ? (
          <img style={{ margin: "8px 0px" }} src={SupabaseIcon} />
        ) : (
          icon
        )}
      </Flex>
      <Text fontWeight={600} fontSize={20}>
        {title}
      </Text>
    </Stack>
  );
};

export default function Backend() {
  return (
    <Box p={6} align={"center"}>
      <Heading
        fontSize={"2xl"}
        fontFamily={"body"}
        fontWeight={500}
        align="center"
        p={4}
        color={useColorModeValue("gray.600", "gray.300")}
      >
        Backend
      </Heading>
      <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 3 }} spacing={16}>
        <Feature icon={<Icon as={NodeIcon} w={20} h={20} />} title={"NodeJS"} />
        <Feature
          icon={<Icon as={ExpressIcon} w={20} h={20} />}
          title={"ExpressJS"}
        />
        {/* <Feature
					icon={<Icon as={MongoDBIcon} w={20} h={20} />}
					title={"SQL"}
				/> */}
        <Feature icon={<Icon as={MySQLIcon} w={20} h={20} />} title={"MySQL"} />
        <Feature
          icon={<Icon as={PostgresqlIcon} w={20} h={20} />}
          title={"PostgreSQL"}
        />
        <Feature
          icon={<Icon as={MongoDBIcon} w={20} h={20} />}
          title={"MongoDB"}
        />
        <Feature
          icon={<Icon as={PrismaIcon} w={20} h={20} />}
          title={"Prisma"}
        />
        <Feature
          iconType={"imagefile"}
          icon={SupabaseIcon}
          title={"Supabase"}
        />
        <Feature
          icon={<Icon as={StrapiIcon} w={20} h={20} />}
          title={"Strapi"}
        />
      </SimpleGrid>
    </Box>
  );
}
